import palette from "../../../styles/palette";

export default {
    selectableContainer: {
        overflow: "hidden",
        width: "100%",
        border: `solid 1px ${palette.field.border.primary}`,
        borderRadius: "5px",
    } as React.CSSProperties,

    selectableItem: {
        cursor: "pointer",
        padding: 10,
        borderBottom: `solid 1px ${palette.field.border.primary}`,
    } as React.CSSProperties,
    selectableItemLast: {
        borderBottom: 'none',
    } as React.CSSProperties,
    selectableItemActive: {
        fontWeight: "bold",
        backgroundColor: palette.active.secondary,
        color: palette.active.primary
    } as React.CSSProperties,
    bulletActive: {
        backgroundColor: palette.active.primary,
        height: 5,
        width: 5,
        marginBottom: 3,
        borderRadius: 10,
        marginRight: 7,
        display: "inline-block"
    },
    bulletHidden: {
        display: "none"
    }

}